import WarehouseShopData from "@/http/data/warehouse-shop-data";
import WarehouseShopOrderData from "@/http/data/warehouse-shop-order-data";

export enum WarehouseShopStatus {
    Failed = "failed",
    Unauthenticated = "unauthenticated",
    Forbidden = "forbidden",
    Empty = "empty",
    Loading = "loading",
    Ready = "ready"
}

export default class WarehouseShopState {
    shop: WarehouseShopData|null = null;

    openOrders: WarehouseShopOrderData[] = [];

    productThumbnailUrls: Record<number, string> = {};

    shopStatus: WarehouseShopStatus =
        WarehouseShopStatus.Failed;

    ordersStatus: WarehouseShopStatus =
        WarehouseShopStatus.Failed;

    selectedBuilding: string|null = null;

    isSaving = false;

    isInitialized = false;
}